import {
    useMutation, UseMutationResult, useQueryClient, UseMutationOptions,
} from '@tanstack/react-query';
import { deleteRelevanceTestDefinition } from 'src/mutations/deleteRelevanceTestDefinition';
import { QUERY_KEY } from 'src/queries/queryRelevanceTestDefinition';

type TestDef = Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition;
type QueryKey = App.RelevanceTestDefinitions.QueryKey;

export const useDeleteRelevanceTestDefinition = (
    options?: Omit<UseMutationOptions<TestDef, Error, TestDef, QueryKey>, 'mutationFn'>,
): UseMutationResult<void, Error, App.RelevanceTestDefinitions.DeleteMutationVariables> => {
    const queryClient = useQueryClient();

    return useMutation(
        deleteRelevanceTestDefinition,
        {
            onSuccess: () => {
                queryClient.cancelQueries([QUERY_KEY]);
                queryClient.invalidateQueries([QUERY_KEY]);
            },
            useErrorBoundary: options?.useErrorBoundary ?? true,
        },
    );
};
